import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { SINGULAR_SDK_KEY, SINGULAR_SDK_SECRET } from '../../utils/constants';

const SingularInit: React.FC = () => {
  const isInitialized = useRef(false);
  const location = useLocation();

  // Initialize SDK once on mount
  useEffect(() => {
    if (!isInitialized.current && window.singularSdk && window.SingularConfig) {
      if (!SINGULAR_SDK_KEY || !SINGULAR_SDK_SECRET) {
        isInitialized.current = true;
      } else {
        const config = new window.SingularConfig(
          SINGULAR_SDK_KEY,
          SINGULAR_SDK_SECRET,
          window.location.hostname.split('.').reverse().join('.'), // turn app.bighealth.com into com.bighealth.app
        ).withInitFinishedCallback((initParams: { singularDeviceId: string; }) => {
          const { singularDeviceId } = initParams;
          // Below is for local testing purposes only
          // Console logs do nothing in production.
          console.log('Singular Device ID:', singularDeviceId);
          // Store for analytics or pass to other services
        });
        window.singularSdk.init(config);
        isInitialized.current = true;
        // Below is needed to track the initial app open event
        // and register it to Singular.
        window.singularSdk.event('app_opened', {
          path: window.location.pathname,
          referrer: document.referrer,
        });
      }
    }
  }, []); // Empty dependency - runs once

  // Track page visits on route changes (NOT on initial mount)
  // We might be able to move this to the HOC that wraps Routes
  // so we have a unified place for route change tracking across analytics services.
  useEffect(() => {
    if (isInitialized.current && window.singularSdk) {
      window.singularSdk.pageVisit();
    }
  }, [location.pathname]); // Runs when pathname changes

  return null;
};

export default SingularInit;
